import script from "./MappaPin.vue?vue&type=script&setup=true&lang=js"
export * from "./MappaPin.vue?vue&type=script&setup=true&lang=js"

import "./MappaPin.vue?vue&type=style&index=0&id=2a0a3e7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0a3e7c"]])

export default __exports__